import * as env from '../config/environment.json';

// Base url for links we hand over to the backend, e.g. print urls that are rendered
// server side. Follows the host the user is actually on, so branch environments
// (demo, test-sfub, ...) render from their own frontend instead of the shared test one.
// Falls back to the configured url when running locally, which the backend cannot reach.
export function externalBaseUrl() {
  let origin = window.location.origin;

  if (!origin || /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(:|$)/i.test(origin)) {
    return env.baseUrl;
  }

  return `${origin}/`;
}
